import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ClientService} from '../../../Services/client.service';
import {AuthService} from '../../../auth/AuthService';
import {first} from 'rxjs/operators';
import swal from "sweetalert2";
import {ActivatedRoute, Router} from '@angular/router';
import {IOffice} from '../../../Model/Office';
import {OfficeService} from '../../../Services/office.service';
import {statesDropdown} from '../../../shared/StatesUS';

@Component({
  selector: 'pm-add-update-office',
  templateUrl: './add-update-office.component.html',
  styleUrls: ['./add-update-office.component.css']
})
export class AddUpdateOfficeComponent implements OnInit {
    officeForm!: FormGroup;
    officeId :any;
    status:boolean = false;
    clientList: any = [];
    phoneType: any = [
        {value: 'Mobile', viewValue: 'Mobile'},
        {value: 'Work', viewValue: 'Work'},
        {value: 'Home', viewValue: 'Home'},
    ];
    stateList:any = statesDropdown
    constructor(private fb: FormBuilder,
                private clientServices: ClientService,
                private officeService: OfficeService,
                private authService: AuthService,
                private activatedRoute: ActivatedRoute,
                private route: Router) {

        this.officeId = this.activatedRoute.snapshot.paramMap.get('id');

        this.officeForm = this.fb.group({
            id:[],
            name: [null, Validators.required],
            email: [null, [Validators.required, Validators.email]],
            number: [null, [Validators.required, Validators.pattern(/^\d{10}$|^\d{3}-\d{3}-\d{4}$/)]],
            clientId:[this.authService.clientId, Validators.required],
            phoneType: [null, Validators.required],
            firstLine: [null, Validators.required],
            secondLine:[null, Validators.required],
            city: [null, Validators.required],
            state: [null, Validators.required],
            zip: [null, Validators.required],
        });

        this.getRequiredList();

        if(this.officeId){
            let reqData:any ={
                officeId : this.officeId
            }
            this.officeService.getOfficeDetails(reqData).pipe(first()).subscribe(
                (response: any) => {
                    if (response != undefined) {
                        let data = response;
                        this.status = data.active ? data.active : false;
                        this.officeForm.patchValue({
                            id:data.id,
                            name: data?.name ? data.name: null,
                            email: data?.contact?.email ? data.contact.email : null,
                            clientId: data?.client.id ? data.client.id : null,
                            number: data?.contact?.phones[0]?.number ? data.contact.phones[0].number : null,
                            phoneType: data?.contact?.phones[0]?.phoneType ? data.contact.phones[0].phoneType : null,
                            firstLine: data?.address?.firstLine ? data.address.firstLine : null,
                            secondLine: data?.address?.secondLine ? data.address.secondLine : null,
                            city: data?.address?.city ? data.address.city : null,
                            state: data?.address?.state ? data.address.state : null,
                            zip: data?.address?.zip ? data.address.zip : null,
                        });
                    } else {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: response.message,
                            showConfirmButton: false,
                            timer: 5000
                        });
                    }
                },
                (error) => {
                    swal.fire({
                        title: 'Error!',
                        icon: 'error',
                        text: error.error.message,
                        showConfirmButton: false,
                        timer: 5000
                    });
                }
            );
        }
    }

    ngOnInit(): void {
        //this.officeForm.get('clientId')?.disable();
    }

    getRequiredList() {
        let params = {
            isUserClient:true
        }
        this.clientServices.getUserClientDetails(params).pipe(first()).subscribe(
            (response: any) => {
                if (response) {
                    this.clientList = response;
                }
            });
    }

    // Change status
    changeStatus(status:any){
        if(status == true){
            this.status = false;
        }else{
            this.status = true;
        }
    }

    // Register client function / update
    onRegister(): any {
        this.officeForm.markAllAsTouched();
        if (this.officeForm.valid) {
            let reqData: IOffice = {
                name: this.officeForm.controls.name.value ? this.officeForm.controls.name.value : null,
                address: {
                    firstLine: this.officeForm.controls.firstLine.value ? this.officeForm.controls.firstLine.value : null,
                    secondLine: this.officeForm.controls.secondLine.value ? this.officeForm.controls.secondLine.value : null,
                    city: this.officeForm.controls.city.value ? this.officeForm.controls.city.value : null,
                    state: this.officeForm.controls.state.value ? this.officeForm.controls.state.value : null,
                    zip: this.officeForm.controls.zip.value ? this.officeForm.controls.zip.value : null
                },
                client: {
                    id: this.officeForm.controls.clientId.value ? this.officeForm.controls.clientId.value : null
                },
                contact: {
                    phones: [
                        {
                            number: this.officeForm.controls.number.value ? this.officeForm.controls.number.value : null,
                            phoneType: this.officeForm.controls.phoneType.value ? this.officeForm.controls.phoneType.value : null
                        }
                    ],
                    email: this.officeForm.controls.email.value ? this.officeForm.controls.email.value : null,
                },
                active: this.status
            };

            // update logic
            if(this.officeId){
                let params = {
                    officeId: this.officeId,
                }
                this.officeService.updateOffice(reqData,params).pipe(first()).subscribe(
                    (response: any) => {
                        if (response != undefined) {
                            this.route.navigate(['office']);
                            swal.fire({
                                icon: 'success',
                                text: 'Office :- ' + `" ${reqData.name} "`+ ' updated successfully.',
                                showConfirmButton: false,
                                timer: 3000
                            });
                        } else {
                            swal.fire({
                                title: 'Error!',
                                icon: 'error',
                                text: response.message,
                                showConfirmButton: false,
                                timer: 5000
                            });
                        }
                    },
                    (error) => {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: error.error.message,
                            showConfirmButton: false,
                            timer: 5000
                        });
                    }
                );
            }
            // add / register logic
            else{
                this.officeService.officeRegistration(reqData).pipe(first()).subscribe(
                    (response: any) => {
                        if (response != undefined) {
                            this.route.navigate(['office']);
                            swal.fire({
                                icon: 'success',
                                text: 'Office :- ' + `" ${reqData.name} "`+ ' registered successfully.',
                                showConfirmButton: false,
                                timer: 3000
                            });
                        } else {
                            swal.fire({
                                title: 'Error!',
                                icon: 'error',
                                text: response.message,
                                showConfirmButton: false,
                                timer: 5000
                            });
                        }
                    },
                    (error) => {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: error.error.message,
                            showConfirmButton: false,
                            timer: 5000
                        });
                    }
                );
            }

        }
    }

}
